import React from 'react';
import PropTypes from 'prop-types';

import {
    StyledCard,
    StyledCardContent,
    Text,
    CreditsIcon,
    StyledFormHelperText,
} from '../../index';

const TotalCreditsCard = ({ data, error }) => {
    return (
        <StyledCard padding="20px">
            <StyledCardContent
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
            >
                <div>
                    <Text $fontSize="24px">Estimated total credits</Text>
                    <Text $fontSize="12px" $color="gray2">
                        The system will send a notification to the client that the provider invited
                        to attend the session.
                    </Text>
                </div>
                <div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            columnGap: '10px',
                            justifyContent: 'flex-end',
                        }}
                    >
                        <CreditsIcon width="20" height="20" />
                        <Text $fontSize="20px">{data}</Text>
                    </div>
                    {error && (
                        <StyledFormHelperText error style={{ padding: 0 }}>
                            Insufficient funds
                        </StyledFormHelperText>
                    )}
                </div>
            </StyledCardContent>
        </StyledCard>
    );
};

TotalCreditsCard.propTypes = {
    data: PropTypes.number,
    error: PropTypes.bool,
};

export default TotalCreditsCard;
